// extracted by mini-css-extract-plugin
export default {"rating":"oz-z","numberOfStars":"pz-z","count":"qz-z","barGraphSpacing":"rz-z","barGraph":"sz-z"};